import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { startEmbedBridge } from './lib/embedBridge';
import { Header } from './components/Header';
import BusinessPricing from './pages/BusinessPricing';
import BusinessPricingThankYou from './pages/BusinessPricingThankYou';
import './App.css';

function App() {
  useEffect(() => startEmbedBridge(), []);

  return (
    <div className="bonza-widget min-h-screen bg-[#F8F9FA]">
      <Header />
      <Toaster position="top-center" />
      <Routes>
        <Route path="/business-pricing" element={<BusinessPricing />} />
        <Route path="/business-pricing-thank-you" element={<BusinessPricingThankYou />} />
        {/* Redirect root to business-pricing */}
        <Route path="/" element={<Navigate to="/business-pricing" replace />} />
        <Route path="*" element={<Navigate to="/business-pricing" replace />} />
      </Routes>
    </div>
  );
}

export default App;
